// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"2614301b","453":"cfae9477","777":"55bcdc00"}[chunkId] + ".chunk.js";
};